export default "__VITE_ASSET__CBwE1gPF__"